import { getSpacePostTypeGQLQuery, getSpacePostTypesGQLQuery, updateSpacePostTypeGQLMutation, } from '../../graphql/index.js';
export class SpacePostTypeClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getSpacePostTypesGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.spacePostTypes;
    }
    async get(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getSpacePostTypeGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.spacePostType;
    }
    async update(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: updateSpacePostTypeGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.updatedSpacePostType;
    }
}
//# sourceMappingURL=space-post-type.client.js.map